import { useEffect, useRef } from 'react';

/**
 * Invokes `onGrew` after `delayMs` whenever `panelCount` increases. Used to
 * scroll the surface back to the right edge after a new sidepanel opens, so
 * the newly added panel becomes visible.
 */
export const useScrollOnPanelGrow = (panelCount: number, delayMs: number, onGrew: () => void): void => {
    const previousCountRef = useRef(panelCount);

    useEffect(() => {
        const grew = panelCount > previousCountRef.current;
        previousCountRef.current = panelCount;

        if (!grew) {
            return;
        }

        const timerId = window.setTimeout(onGrew, delayMs);

        return () => window.clearTimeout(timerId);
    }, [delayMs, onGrew, panelCount]);
};
